import { ArrowBack, DeleteOutlined, SaveOutlined } from "@mui/icons-material";
import { Alert, Autocomplete, Box, Checkbox, Divider, Snackbar, Stack, Switch, TextField, Typography } from "@mui/material";
import { ImagePlus, Info, Trash2 } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { Controller, useForm, useWatch } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { Button, IconInfo } from "../../../components";
import { ErrorScreen } from "../../../components/error-screen";
import { Loading } from "../../../components/loading";
import { fetchTextoPadrao } from "../../../services";
import { useToastStore, useUserStore } from "../../../stores";
import { colorPrimary, textFieldStyle } from "../../../theme";
import { formatDateFromISO, formatHourFromISO, maskCurrencyBRL, maskHour, maskPlaca, mergeDateAndHour } from "../../../utils/mask/MaskUtils";
import { AutoCompleteField } from "../components/AutoComplete";
import { TextFieldController } from "../components/TextFieldComponent";
import { AcessoriosDTO, CompanyDTO, CriarAnuncioDTOV2, MarcasFormDTO, ModelosFormDTO, NewAdsOrVeichleForm, RenovarAdDto, VehicleImage } from "../dto/CompanyDTO";
import { formatCurrency, getCombustivel, getCombustivelId, getImageSrc, getSelectedAcessorios, getTransmissaoId, getTransmissaoLabel, parseCurrency, parseCurrencyToDecimal } from "../helpers/ComapnyHelpers";
import { acessoriosMock, combustiveis, transmissao, typeOfVehicle } from "../mocks/CompanyMocks";
import { createAnuncioV2, deletePhoto, fetchAdById, fetchCompanies, fetchFipe, fetchMarcas, fetchModelo, putDesativaAnuncio, putPublicaAnuncio, putUpdateAnuncioV2, renovarAd, updatePhotoCapa } from "../repository/ComapnyRepository";



export function CreateOrUpdateAdsTab() {
  const navigate = useNavigate();
  const {adId} = useParams();
  const { setToast } = useToastStore();
  const { user } = useUserStore();
  const isEdit = adId !== null;
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  const [toastType, setToastType] = useState<"success" | "error">("error");
  const jaCarregouRef = useRef(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [companies, setCompanies]= useState<CompanyDTO [] | null>(null);
 const {
  control,
  handleSubmit,
  formState: { errors },
  reset,
  setValue,
} = useForm<NewAdsOrVeichleForm>(
  {defaultValues: {
      companyId: null,
      placa: null,
      tipo_veiculo: null,
      marca: null,
      modelo: null,
      anoFabricacao: null,
      anoModelo: null,
      km: null,
      motor: null,
      combustivel: null,
      transmissao: null,
      cor: null,
      portas: null,
      data_anuncio_finalizacao: null,
      hora_finalizacao_anuncio: null,
      data_leilao_finalizacao: null,
      hora_leilao_finalizacao_anuncio: null,
      valor_inicial: null,
      valor_compre_agora: null,
      texto_padrao: null,
      observacao: null,
      avarias: null,
    },});
  const [laudoFile, setLaudoFile] = useState<File | null>(null);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [images, setImages] = useState<VehicleImage[]>([]);
  const photosInputRef = useRef<HTMLInputElement | null>(null);
  const [acessorios, setAcessorios] = useState<AcessoriosDTO[]>(acessoriosMock);
  const [marcas, setMarcas]= useState<MarcasFormDTO[]>([]);
  const [modelos, setModelos]= useState<ModelosFormDTO[]>([]);
  const [isLeilao, setLeilao] = useState<boolean>(true);
  const [isCotacao, setCotacao] = useState<boolean>(false);
  const [laudoLink, setLaudoLink] = useState<string | null>(null);
  const [status, setStatus] = useState<string>("");
  const [ativo, setAtivo] = useState<string>("");
  const veiculoId = useWatch({control, name:"id"});
  const selectedCompany= useWatch({
  control,
  name: "companyId",
  });
  const selectedTypeOfVehicle = useWatch({
  control,
  name: "tipo_veiculo",
  });
const [vehicleLocked, setVehicleLocked] = useState(false);
const [selectedMarcaId, setSelectedMarcaId] = useState<number | null>(null);
const [selectedModeloObj, setSelectedModeloObj] = useState<ModelosFormDTO | null>(null);
const [preloadedModeloId, setPreloadedModeloId] = useState<number | null>(null);
const handleOpenPhotosDialog = () => {
  photosInputRef.current?.click();
};

const handleRemovePhoto = async (indexToRemove: number) => {
  const image = images[indexToRemove];

  //  IMAGEM NOVA (File) → só remove local
  if (image.isNew) {
    if (image.previewUrl) {
      URL.revokeObjectURL(image.previewUrl);
    }

    setImages((prev) =>
      prev.filter((_, index) => index !== indexToRemove)
    );

    return;
  }

  //  IMAGEM EXISTENTE (API)
  try {
    setLoading(true);

    await deletePhoto(
      veiculoId!,
      image.url!
    );

    setImages((prev) =>
      prev.filter((_, index) => index !== indexToRemove)
    );
  } catch (error) {
    console.error(error);
    setToastType("error");
    setToastMsg("Erro ao remover imagem");
    setToastOpen(true);
  } finally {
    setLoading(false);
  }
};




 const handleToggleAcessorio = (id: number) => {
  setAcessorios((prev) =>
    prev.map((item) =>
      item.id === id
        ? { ...item, isActive: !item.isActive }
        : item
    )
  );
};


const handleSetCover =async (index: number) => {
  const image = images[index];
  if (image.isNew) {
      setImages((prev) =>
    prev.map((img, i) => ({
      ...img,
      isCapa: i === index,
    }))
  );
  return;
  }
  try {
    const result = await updatePhotoCapa(veiculoId!,Number(adId), image.url!);
    if (result ===true) {
  setImages((prev) =>
      prev.map((img, i) => ({
        ...img,
        isCapa: i === index,
      }))
    );
    }
  } catch (error) {
    console.error(error);
    setToastType("error");
    setToastMsg("Erro ao atualizar a capa");
    setToastOpen(true);
  } finally {
    setLoading(false);
  }

};


const handleSelectPhotosInput = (
  e: React.ChangeEvent<HTMLInputElement>
) => {
  const files = Array.from(e.target.files ?? []);

  setImages((prev) => {
    const hasCover = prev.some((i) => i.isCapa);

    const mapped: VehicleImage[] = files.map((file, index) => ({
      file,
      previewUrl: URL.createObjectURL(file),
      isNew: true,
      isCapa: !hasCover && index === 0,
    }));

    return [...prev, ...mapped];
  });
};

const handleOpenFileDialog = (e?: React.MouseEvent) => {
  e?.preventDefault();
  e?.stopPropagation();
  fileInputRef.current?.click();
};

const handleSelectLaudo = (
  event: React.ChangeEvent<HTMLInputElement>
) => {
  const file = event.target.files?.[0] ?? null;
  setLaudoFile(file);
};

const handleClearVehicle = () => {
  setValue("tipo_veiculo", null);
  setValue("marca", null);
  setValue("modelo", null);
  setMarcas([]);
  setModelos([]);
  setSelectedMarcaId(null);
  setSelectedModeloObj(null);
  setVehicleLocked(false);
};

const fetchCompanie = async () => {
  try {
    const userId = user?.id;
    const result = await fetchCompanies(userId);
    if (!result?.success) {
      return;
    }
    setCompanies(result.data);
  } catch (error) {
  }
}

const fetchModelos = async (marcaId: number) => {
  try {
    setLoading(true);
    const result = await fetchModelo(marcaId);
    if (!result?.success) {
      setToastType("error");
      setToastMsg(result?.message ?? "Erro ao buscar os Modelos.");
      setToastOpen(true);
      return;
    }
    setModelos(result.data);
  } catch {
    setToastType("error");
    setToastMsg("Erro ao buscar as Modelos.");
    setToastOpen(true);
  } finally {
    setLoading(false);
  }
};

const getTextPadrao = async(concessionaria_id: number) => {
  try {
    setLoading(true);
    const userId = user?.id;
    const result = await fetchTextoPadrao(userId!,concessionaria_id );
    if (!result?.success) {
      setToastType("error");
      setToastMsg(result?.message ?? "Erro em buscar o texto padrão.");
      setToastOpen(true);
      return;
    }
    setValue("texto_padrao", result.data);
  } catch (error) {
      setToastType("error");
      setToastMsg("Erro em buscar o texto padrão.");
      setToastOpen(true);
      return;
  } finally {
    setLoading(false);
  }
};

const getMarcas = async (typeVehicleId: number) => {
  try {
    setLoading(true);

    const result = await fetchMarcas(typeVehicleId);

    if (!result?.success) {
      setToastType("error");
      setToastMsg(result?.message ?? "Erro ao buscar as marcas");
      setToastOpen(true);
      return;
    }

    setMarcas(result.data);
  } catch {
    setToastType("error");
    setToastMsg("Erro ao buscar as marcas.");
    setToastOpen(true);
  } finally {
    setLoading(false);
  }
};

const submitPublicaAd = async ()=> {
  try {
    setLoading(true);
    const result = await putPublicaAnuncio(Number(adId));
      setToast({variant:`${result.success ===true? "success" : "error"}`, message:result.message});
      if(result) {
        navigate("/anuncios");
      }
  } catch (error) {
  setToast({variant: "error", message:'Erro. Contate o administrador.'});
  } finally{
    setLoading(false);
  }
};

const submitDesativarAd = async ()=> {
  try {
    setLoading(true);
    const result = await putDesativaAnuncio(Number(adId));
      setToast({variant:`${result.success ===true? "success" : "error"}`, message:result.message});
      if(result) {
        navigate("/anuncios");
      }
  } catch (error) {
  setToast({variant: "error", message:'Erro. Contate o administrador.'});
  } finally{
    setLoading(false);
  }
};


const onSubmitAds = async (data: NewAdsOrVeichleForm) => {
  setLoading(true);

  try {
    const fotos = images
      .filter(img => img.isNew && img.file)
      .map(img => ({
        foto: img.file as File,
        capa: img.isCapa,
      }));

    if (images.length === 0) {
      setToast({
        message: "Informe ao menos uma foto do veículo",
        variant: "error",
      });
      setLoading(false);
      return;
    }
    const codigoFipe = selectedModeloObj?.codigo_fipe?.trim() ?? "";
    const valorFipe = codigoFipe ? await fetchFipe(codigoFipe, Number(data.anoModelo)) : null;

    const payload: CriarAnuncioDTOV2 = {
      id_concessionaria: Number(data.companyId),
      codigo_fipe: codigoFipe,
      placa: data.placa ?? "",
      tipo_veiculo: String(data.tipo_veiculo),
      marca: data.marca ?? "",
      modelo: data.modelo ?? "",
      valor_fipe: valorFipe,
      ano_fabricacao: Number(data.anoFabricacao) ?? 0,
      ano_modelo: Number(data.anoModelo) ?? 0,
      km: Number(data.km) ?? 0,

      motor: data.motor ?? "",
      combustivel: getCombustivel(data.combustivel) ?? "",
      transmissao: getTransmissaoLabel(data.transmissao) ?? "",
      cor: data.cor ?? "",
      portas: Number(data.portas),


      observacao: data.observacao ?? "",
      avarias: data.avarias ?? null,

      laudo_file: laudoFile,

      acessorios: getSelectedAcessorios(acessorios),
      fotos,
    
      compre_agora:parseCurrencyToDecimal(data.valor_compre_agora),
      data_finalizacao: mergeDateAndHour(  data.data_anuncio_finalizacao,  data.hora_finalizacao_anuncio ),
      data_leilao: mergeDateAndHour( data.data_leilao_finalizacao, data.hora_leilao_finalizacao_anuncio ),
      texto_padrao: data.texto_padrao,
      tipo_anuncio:isCotacao ? "C" : isLeilao ? "L" : "N",
      valor_inicial: parseCurrencyToDecimal(data.valor_inicial),
    };

    if (
      payload.data_finalizacao &&
      payload.data_leilao &&
      new Date(payload.data_finalizacao) <= new Date(payload.data_leilao)
    ) {
      setToast({
        message: "A data de finalização do anúncio deve ser maior que a data do leilão",
        variant: "error",
      });
      setLoading(false);
      return;
    }

    const result = adId? await putUpdateAnuncioV2(payload, Number(adId)) :  await createAnuncioV2(payload);

    if (!result?.success) {
      setToast({
        message: result.message ?? "Erro. Contate o administrador.",
        variant: "error",
      });
      return;
    }

    setToast({
      message: result.message ?? "Veículo cadastrado com sucesso",
      variant: "success",
    });

    navigate("/anuncios");
  } catch {
    setToast({
      message: "Erro. Contate o administrador.",
      variant: "error",
    });
  } finally {
    setLoading(false);
  }
};






const preloadAdData = async (anuncioId: number) => {
  try {
    setLoading(true);

   const data = await fetchAdById(anuncioId);

    if(!data?.success) {
      setToast({variant:"error", message:data.message});
      return;
    }


  const anuncio = data.data;
  const transmissaoId =   getTransmissaoId(anuncio.veiculos[0].transmissao);
  const combustivelId = getCombustivelId(anuncio.veiculos[0].combustivel);
  setLaudoLink(anuncio.veiculos[0].laudo !==null? anuncio.veiculos[0].laudo : null);
    setVehicleLocked(true);
    setPreloadedModeloId(anuncio.veiculos[0].modelo_id ?? null);
    reset({
      id: anuncio.veiculos[0].id,
      companyId: anuncio.num_id_concessionaria,
      placa: anuncio.veiculos[0].placa,
      tipo_veiculo: typeOfVehicle.find((v) => v.id === Number(anuncio.veiculos[0].tipo_veiculo))?.id , 
      marca: anuncio.veiculos[0].marca ?? "",
      modelo: anuncio.veiculos[0].modelo ?? "",
      anoFabricacao: String(anuncio.veiculos[0].ano_fabricacao),
      anoModelo:String(anuncio.veiculos[0].ano_modelo),
      km: String(anuncio.veiculos[0].km),
      motor: anuncio.veiculos[0].motor,
      combustivel: combustivelId, // mapearemos abaixo
      transmissao: transmissaoId,
      laudo: anuncio.veiculos[0].laudo,
      cor: anuncio.veiculos[0].cor,
      portas: String(anuncio.veiculos[0].portas),
      data_anuncio_finalizacao: formatDateFromISO(anuncio.dat_finalizacao),
      hora_finalizacao_anuncio: formatHourFromISO(anuncio.dat_finalizacao),
      data_leilao_finalizacao: anuncio.data_leilao
        ? formatDateFromISO(anuncio.data_leilao)
        : null,
      hora_leilao_finalizacao_anuncio: anuncio.data_leilao
        ? formatHourFromISO(anuncio.data_leilao)
        : null,
      valor_inicial:formatCurrency(anuncio.val_inicial),
      valor_compre_agora: formatCurrency(anuncio.val_compre_agora),
      texto_padrao: anuncio.texto_padrao,
      observacao: anuncio.veiculos[0].observacao,
      avarias: anuncio.veiculos[0].avarias,
    });
    setAtivo(anuncio.tag_ativo);
    setStatus(anuncio.tag_status);
    //  Estados derivados
    setCotacao(anuncio.tipo_anuncio === "C");
    setLeilao(anuncio.data_leilao != null);
    //  Acessórios
    const acessoriosIds = anuncio.veiculos[0].acessorios.map(
      (a: { id_acessorio: number }) => a.id_acessorio
    );
  setAcessorios((prev) =>
    prev.map((a) => ({
      ...a,
      isActive: acessoriosIds.includes(a.id),
    }))
  );

    //  Fotos existentes (URLs)
    setImages(
      anuncio.veiculos[0].fotos.map((file: any) => ({
        url: `${file.url_foto}`,
        isNew: false,
        adId: adId,
        isCapa: file.capa,
      }))
    );

  } catch (error) {
    console.error(error);
    setToastType("error");
    setToastMsg("Erro ao carregar anúncio.");
    setToastOpen(true);
  } finally {
    setLoading(false);
  }
};

  const handleRenew = async (data: NewAdsOrVeichleForm) => {
    if (!isEdit) return;
    const payload : RenovarAdDto = {
      acessorios: getSelectedAcessorios(acessorios),
      dat_finalizacao: mergeDateAndHour(data.data_anuncio_finalizacao,data.hora_finalizacao_anuncio) ?? "",
    des_avarias: data.avarias ?? "",
    des_combustivel: getCombustivel(data.combustivel) ?? "",
    des_cor: data.cor ??"",
    des_link_laudo_tecnico: null,
    des_motor: data.motor ?? "",
    des_observacao: data.observacao ?? "",
    des_placa: data.placa ?? "",
    des_texto_padrao: data.texto_padrao ?? "",
    des_transmissao: getTransmissaoLabel(data.transmissao) ?? "",
    data_leilao: mergeDateAndHour(data.data_leilao_finalizacao,data.hora_leilao_finalizacao_anuncio) ?? "",
    num_ano_fabricacao: Number(data.anoFabricacao) ?? 0,
    num_ano_modelo: Number(data.anoModelo) ?? 0,
    num_id_veiculo_modelo: selectedModeloObj?.id ?? preloadedModeloId ?? 0,
    num_portas: data.portas ?? "",
    num_quilometragem: data.km ?? "",
    tipo_anuncio: isCotacao? "C" : isLeilao? "L" : "N",
    val_compre_agora: parseCurrency(data.valor_compre_agora?.toString() ?? "0"),
    val_inicial: parseCurrency(data.valor_inicial?.toString() ?? "0"),
    };

    if (payload.tipo_anuncio !== 'C' && payload.val_compre_agora <= payload.val_inicial) {
      setToast({
        message: 'O Valor de Compre Agora precisa ser superior ao Valor Inicial!',
        variant: 'warning',
      });
      setLoading(false);
      return;
    }

    if (
      payload.dat_finalizacao &&
      payload.data_leilao &&
      new Date(payload.dat_finalizacao) <= new Date(payload.data_leilao)
    ) {
      setToast({
        message: "A data de finalização do anúncio deve ser maior que a data do leilão",
        variant: "error",
      });
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const result = await renovarAd(payload, Number(adId));
      if(!result.success) {
        setToast({message: result.message, variant:"error"});
        return;
      }
    setToast({message: result.message, variant:"success"});
    navigate("/anuncios");
    } catch (error) {
        setToast({message: "Erro. Contate o Administrador.", variant:"error"});
    } finally {
      setLoading(false);
    }
   
  };


useEffect(() => {
  if (jaCarregouRef.current) return;

  jaCarregouRef.current = true;
  fetchCompanie();

  if (isEdit && adId) {
    preloadAdData(Number(adId));
  }
}, [isEdit, adId]);


useEffect(() => {
  if (!selectedTypeOfVehicle || vehicleLocked) return;
  getMarcas(selectedTypeOfVehicle);
  setValue("marca", null);
  setValue("modelo", null);
  setSelectedMarcaId(null);
  setSelectedModeloObj(null);
  setModelos([]);
}, [selectedTypeOfVehicle, vehicleLocked]);

useEffect(() => {
  if (!selectedCompany) return;

  getTextPadrao(selectedCompany);
}, [selectedCompany]);

useEffect(() => {
  if (!selectedMarcaId) return;
  fetchModelos(selectedMarcaId);
}, [selectedMarcaId]);




  if (loading) return <Loading fullScreen={true} />;
  if (error) return <ErrorScreen fullScreen />;
 


    return (
      <>
    <Snackbar
    open={toastOpen}
    autoHideDuration={2500}
    onClose={() => setToastOpen(false)}
    anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
    <Alert
    severity={toastType}
    onClose={() => setToastOpen(false)}
    sx={{ width: "100%" }}
    >
    {toastMsg}
    </Alert>
    </Snackbar>
  
<Box display="flex" flexDirection="column" width="100%" height="100%" gap={2}>
<form>
  {/* FORMULÁRIO NOVO ANÚNCIO */}
  <Box
    display="grid"
    gridTemplateColumns="repeat(2, 1fr)"
    gap={4}
    flexGrow={1}
    width="100%"
  >
  <Box borderRadius={1} p={2} gap={1} bgcolor="white">
      <Typography
        fontWeight="bold"
        fontSize="1.3rem"
        color="black"
        mt={2}
      >
        Dados do veículo *
      </Typography>
      <Divider sx={{ width: "100%", my: 2, borderBottomWidth: 2 }} />
      <Box
        display="grid"
        gridTemplateColumns="repeat(1, 1fr)"
        gap={2}
        width="100%"
      >
      <AutoCompleteField
        name="companyId"
        control={control}
        errors={errors}
        options={companies ?? []}
      />
      <TextFieldController
        control={control}
        errors={errors}
        name="placa"
        label="Placa"
        title="Placa"
        placeholder="Ex: ABC-1234"
        required
        mask={maskPlaca}
      />
      <AutoCompleteField
        control={control}
        errors={errors}
        name="tipo_veiculo"
        label="Escolha o tipo de veículo"
        required={true}
        title="Tipo de veículo"
        options={typeOfVehicle}
        disabled={vehicleLocked}
      />
      <Controller
        name="marca"
        control={control}
        rules={{ required: "Marca é obrigatória" }}
        render={({ field }) => (
          <Stack direction="row" width="100%" justifyContent="space-between" alignItems="center">
            <Typography fontWeight={400} width="400px">Marca</Typography>
            <Autocomplete<MarcasFormDTO, false, false, true>
              freeSolo
              fullWidth
              disabled={vehicleLocked}
              options={marcas}
              getOptionLabel={(option) => typeof option === 'string' ? option : option.label}
              inputValue={field.value ?? ""}
              onInputChange={(_, value, reason) => {
                if (reason === 'input' || reason === 'clear') {
                  field.onChange(value || null);
                  setSelectedMarcaId(null);
                  setModelos([]);
                  setValue("modelo", null);
                  setSelectedModeloObj(null);
                }
              }}
              onChange={(_, newValue) => {
                if (typeof newValue === 'string') {
                  field.onChange(newValue || null);
                  setSelectedMarcaId(null);
                } else if (newValue) {
                  field.onChange(newValue.label);
                  setSelectedMarcaId(newValue.id);
                } else {
                  field.onChange(null);
                  setSelectedMarcaId(null);
                }
                setValue("modelo", null);
                setModelos([]);
                setSelectedModeloObj(null);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  sx={textFieldStyle}
                  label="Escolha a marca do veículo"
                  placeholder="marca do veículo"
                  error={!!errors?.marca}
                  helperText={errors?.marca?.message as string | undefined}
                />
              )}
            />
          </Stack>
        )}
      />
      <Controller
        name="modelo"
        control={control}
        rules={{ required: "Modelo é obrigatório" }}
        render={({ field }) => (
          <Stack direction="row" width="100%" justifyContent="space-between" alignItems="center">
            <Typography fontWeight={400} width="400px">Modelo</Typography>
            <Autocomplete<ModelosFormDTO, false, false, true>
              freeSolo
              fullWidth
              disabled={vehicleLocked}
              options={modelos}
              getOptionLabel={(option) => typeof option === 'string' ? option : option.label}
              inputValue={field.value ?? ""}
              onInputChange={(_, value, reason) => {
                if (reason === 'input' || reason === 'clear') {
                  field.onChange(value || null);
                  setSelectedModeloObj(null);
                }
              }}
              onChange={(_, newValue) => {
                if (typeof newValue === 'string') {
                  field.onChange(newValue || null);
                  setSelectedModeloObj(null);
                } else if (newValue) {
                  field.onChange(newValue.label);
                  setSelectedModeloObj(newValue);
                } else {
                  field.onChange(null);
                  setSelectedModeloObj(null);
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  sx={textFieldStyle}
                  label="Escolha o modelo do veículo"
                  placeholder="modelo do veículo"
                  error={!!errors?.modelo}
                  helperText={errors?.modelo?.message as string | undefined}
                />
              )}
            />
          </Stack>
        )}
      />
      {vehicleLocked && (
        <Stack direction="row" justifyContent="flex-end" mt={1}>
          <Button variant="text" type="button" onClick={handleClearVehicle}>
            <DeleteOutlined fontSize="small" />
            <span>Limpar veículo</span>
          </Button>
        </Stack>
      )}
      <TextFieldController
        control={control}
        errors={errors}
        name="anoFabricacao"
        label="Ano de fabricação"
        title="Ano de fabricação"
        placeholder="Informe o ano de fabricação. Ex: 2025"
        required
      />
      <TextFieldController
        control={control}
        errors={errors}
        name="anoModelo"
        label="Ano modelo"
        title="Ano modelo"
        placeholder="Informe o ano do modelo. Ex: 2026" 
        required
      />
      </Box>
  </Box>
  <Box borderRadius={1} p={2} gap={1} bgcolor="white">
      <Typography
        fontWeight="bold"
        fontSize="1.3rem"
        color="black"
        mt={2}
      >
        Propriedades do veículo *
      </Typography>
      <Divider sx={{ width: "100%", my: 2, borderBottomWidth: 2 }} />
      <Box
        display="grid"
        gridTemplateColumns="repeat(1, 1fr)"
        gap={2}
        width="100%"
      >
      <TextFieldController
        control={control}
        errors={errors}
        name="km"
        label="Informe a quilometragem"
        title="Quilometragem"
        placeholder="Ex: 161.200"
        required
      />
      <TextFieldController
        control={control}
        errors={errors}
        name="motor"
        title="Motor"
        label="Motor"
        placeholder="Informe o motor. Ex: 2.2"
        required
      />
      <AutoCompleteField
        control={control}
        errors={errors}
        name="combustivel"
        label="Escolha o combustível"
        required={true}
        title="Combustível"
        options={combustiveis ?? []}
      />
      <AutoCompleteField
        control={control}
        errors={errors}
        label="Escolha a transmissão"
        name="transmissao"
        required={true}
        title="Transmissão"
        options={transmissao ?? []}
      />
      <TextFieldController
        control={control}
        errors={errors}
        name="cor"
        title="Cor"
        label="Cor"
        placeholder="Informe a cor do veículo. Ex: branca"
        required
      />
      <TextFieldController
        control={control}
        errors={errors}
        name="portas"
        label="Portas"
        title="Número de portas"
        placeholder="Informe a quantidade de portas." 
        required
      />
      </Box>
  </Box>
  </Box>
  <Box
    display="grid"
    gridTemplateColumns="repeat(2, 1fr)"
    gap={4}
    flexGrow={1}
    mt={2}
    width="100%"
  >
  <Box borderRadius={1} p={2} gap={1} bgcolor="white">
    <Stack display={"flex"} flexDirection={"row"} gap={1} alignContent={"flex-start"} justifyContent={"flex-start"} justifyItems={"flex-start"} alignItems={"flex-start"} mt={2}>
      <Typography
        fontWeight="bold"
        fontSize="1.3rem"
        color="black"
      >
        Anúncio
      </Typography>
      <IconInfo  title="Infor" icon={<Info size={20}/>}/>
    </Stack>
      <Divider sx={{ width: "100%", my: 2, borderBottomWidth: 2 }} />
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        width="100%"
      >
        <Typography fontWeight={400} width="400px">
          Ativar cotação
        </Typography>

        <Switch
          checked={isCotacao}
          onChange={(e) => setCotacao(e.target.checked)}
          color="primary"
        />
      </Stack>
      <Box
        display="grid"
        gridTemplateColumns="repeat(1, 1fr)"
        gap={2}
        width="100%"
      >
      <TextFieldController
        control={control}
        errors={errors}
        name="data_anuncio_finalizacao"
        label=""
        title="Data de finalização do Anúncio"
        placeholder="00/00/0000"
        required
        width="400px"
        type="date"
      />
      <TextFieldController
        control={control}
        errors={errors}
        name="hora_finalizacao_anuncio"
        label="Horário"
        title="Horário de finalização do anúncio"
        required
        type="time"
      />
      {!isCotacao && (
    <Stack display={"flex"} flexDirection={"row"} gap={1} alignContent={"flex-start"} justifyContent={"flex-start"} justifyItems={"flex-start"} alignItems={"flex-start"} mt={2}>
      <Typography
        fontWeight="bold"
        fontSize="1.3rem"
        color="black"
      >
        Leilão
      </Typography>
      <IconInfo  title="Infor" icon={<Info size={20}/>}/>
    </Stack>
      )}
    {!isCotacao && (
      <Divider sx={{ width: "100%", my:0, borderBottomWidth: 2 }} />
    )}
      {!isCotacao && (
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        width="100%"
      >
        <Typography fontWeight={400} width="400px">
          Ativar Leilão
        </Typography>

        <Switch
          checked={isLeilao}
          onChange={(e) => setLeilao(e.target.checked)}
          color="primary"
        />
      </Stack>
      )}
      {!isCotacao && isLeilao && (
        <TextFieldController
          control={control}
          errors={errors}
          name="data_leilao_finalizacao"
          label=""
          title="Data de finalização do Leilão"
          placeholder="00/00/0000"
          width="400px"
          type="date"
        />
      )}
      {!isCotacao && isLeilao && (
      <TextFieldController
        control={control}
        errors={errors}
        name="hora_leilao_finalizacao_anuncio"
        label="Horário"
        title="Horário de finalização do Leilão"
        placeholder="00:00"
        type="time"
        mask={maskHour}
      />
      )}
      <Typography
        fontWeight="bold"
        fontSize="1.3rem"
        color="black"
        mt={2}
      >
        Valores *
      </Typography>
      <Divider sx={{ width: "100%", my:0, borderBottomWidth: 2 }} />
      <TextFieldController
        control={control}
        errors={errors}
        name="valor_inicial"
        label="Valor Inicial"
        title="Valor Inicial"
        placeholder="R$ 50.000,00"
        required
        mask={maskCurrencyBRL}
      />
      <TextFieldController
        control={control}
        errors={errors}
        name="valor_compre_agora"
        label="Valor compre Agora"
        title="Valor de compre Agora"
        placeholder="R$ 60.000,00"
        required
        mask={maskCurrencyBRL}
      />
      <Typography
        fontWeight="bold"
        fontSize="1.3rem"
        color="black"
        mt={2}
      >
        Texto padrão *
      </Typography>
      <Divider sx={{ width: "100%", my: 0, borderBottomWidth: 2 }} />
      <Controller
        name="texto_padrao"
        control={control}
        rules={{ required: "Texto padrão é obrigatório" }}
        render={({ field }) => (
        <TextField
          {...field}
          sx={textFieldStyle}
          fullWidth
          multiline
          rows={4}
          label="Texto padrão"
          placeholder="Texto padrão da concessionária para o anúncio da cotação."
          error={!!errors?.texto_padrao}
          helperText={errors?.texto_padrao?.message}
        />
        )}
      />
      <Typography
        fontWeight="bold"
        fontSize="1.3rem"
        color="black"
        mt={2}
      >
        Observações *
      </Typography>
      <Divider sx={{ width: "100%", my: 0, borderBottomWidth: 2 }} />
      <Controller
        name="observacao"
        control={control}
        rules={{ required: "Observação padrão é obrigatório" }}
        render={({ field }) => (
        <TextField
          {...field}
          sx={textFieldStyle}
          fullWidth
          multiline
          rows={4}
          label="Observações essenciais"
          placeholder="Escreva observações relevantes sobre o veículo para aparecer na 
tela do anúncio de cotação."
          error={!!errors?.observacao}
          helperText={errors?.observacao?.message}
        />
        )}
      />
      <Typography
        fontWeight="bold"
        fontSize="1.3rem"
        color="black"
        mt={2}
      >
        Avarias *
      </Typography>
      <Divider sx={{ width: "100%", my: 0, borderBottomWidth: 2 }} />
      <Controller
        name="avarias"
        control={control}
        rules={{ required: "Avarias padrão é obrigatório" }}
        render={({ field }) => (
        <TextField
          {...field}
          sx={textFieldStyle}
          fullWidth
          multiline
          rows={4}
          label="Avarias & Defeitos"
          placeholder="Escreva possíveis avarias do veículo."
          error={!!errors?.avarias}
          helperText={errors?.avarias?.message}
        />
        )}
      />
      <Typography
        fontWeight="bold"
        fontSize="1.3rem"
        color="black"
        mt={2}
      >
        Laudo *
      </Typography>
      <Divider sx={{ width: "100%", my: 0, borderBottomWidth: 2 }} />
      <Box
        mt={2}
        p={2}
        borderRadius={2}
        display="flex"
        alignItems="center"
        flexDirection={"column"}
        gap={2}
        bgcolor="white"
        border="1px solid #dee2e6"
      >
        <input
          ref={fileInputRef}
          type="file"
          accept="application/pdf"
          hidden
          onChange={handleSelectLaudo}
        />
        <Stack display={"flex"} flexDirection={"column"} gap={2} alignContent={"flex-start"} justifyContent={"flex-start"} alignItems={"center"}>
                  <Button
          variant="contained"
          type="button"
          onClick={(e) => handleOpenFileDialog(e)}
        >
          Selecionar arquivo
        </Button>

        <Typography
          fontSize="0.9rem"
          color={laudoFile ? "black" : "text.secondary"}
        >
          {laudoFile
            ? laudoFile.name
            : laudoLink ?"Observação: Ao realizar o upload de um novo laudo e clicar no botão salvar, o laudo anterior será substituído." : "Nenhum laudo adicionado"}
        </Typography>
        </Stack>
        {adId && laudoLink && (
          <a
            href={laudoLink?.includes('hmlv2api.avaliadordigital')? laudoLink : `https://www.canaldorepasse.com.br/anuncios/fotos/${adId}/${laudoLink}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <Typography
              fontWeight={400}
              fontSize="1rem"
              color={colorPrimary}
              sx={{ cursor: "pointer" }}
            >
              Visualizar Laudo cautelar
            </Typography>
          </a>
        )}
      </Box>
<Typography
  fontWeight="bold"
  fontSize="1.3rem"
  color="black"
  mt={2}
>
  Fotos do veículo *
</Typography>

<Divider sx={{ width: "100%", my: 0, borderBottomWidth: 2 }} />

{/* INPUT ESCONDIDO */}
<input
  ref={photosInputRef}
  type="file"
  accept="image/*"
  multiple
  hidden
  onChange={handleSelectPhotosInput}
/>

<Box
  mt={2}
  p={4}
  borderRadius={2}
  display="flex"
  flexDirection="column"
  alignItems="center"
  justifyContent="center"
  gap={1}
  bgcolor="white"
  border="2px dashed #dee2e6"
  sx={{
    cursor: "pointer",
    transition: "all .2s ease",
    "&:hover": {
      borderColor: colorPrimary,
      backgroundColor: "rgba(255, 102, 0, 0.04)",
    },
  }}
  onClick={handleOpenPhotosDialog}
>
  <ImagePlus size={40} color={colorPrimary} />

  <Typography
    fontWeight={600}
    fontSize="0.95rem"
    color="black"
  >
    Adicionar fotos
  </Typography>

  <Typography
    fontSize="0.8rem"
    color="text.secondary"
  >
    {images.length > 0
      ? `${images.length} foto(s) selecionada(s)`
      : "Clique para selecionar uma ou mais fotos"}
  </Typography>
</Box>
{images.length > 0 && (
  <Box
    mt={2}
    display="grid"
    gridTemplateColumns="repeat(auto-fill, minmax(120px, 1fr))"
    gap={2}
  >
    {images.map((image, index) => {
      const src = getImageSrc(image);

      return (
        <Box
          key={`${image.url ?? image.file?.name}-${index}`}
          position="relative"
          borderRadius={2}
          overflow="hidden"
          border="1px solid #dee2e6"
          sx={{
            cursor: "pointer",
            "&:hover .overlay": {
              opacity: 1,
            },
          }}
        >
          {/* IMAGEM */}
          <img
            src={src}
            alt="Foto do veículo"
            style={{
              width: "100%",
              height: "120px",
              objectFit: "cover",
              display: "block",
            }}
          />
          {/* BADGE CAPA */}
          {image.isCapa && (
            <Box
              position="absolute"
              top={8}
              left={8}
              px={1}
              py={0.3}
              borderRadius={1}
              bgcolor={colorPrimary}
              color="white"
              fontSize="0.7rem"
              fontWeight={600}
              zIndex={2}
            >
              CAPA
            </Box>
          )}
{/* OVERLAY */}
<Box
  className="overlay"
  position="absolute"
  display="flex"
  alignItems="center"
  justifyContent="center"
  gap={2}
  bgcolor="rgba(0,0,0,0.55)"
  sx={{
    inset: 0,
    opacity: 0,
    transition: "opacity .2s ease",
  }}
>

  {/* DEFINIR CAPA */}
  {!image.isCapa && (
    <Box
      onClick={(e) => {
        e.stopPropagation();
        handleSetCover(index);
      }}
      sx={{
        width: 40,
        height: 40,
        borderRadius: "50%",
        backgroundColor: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        transition: "all .2s ease",
        "&:hover": {
          backgroundColor: colorPrimary,
          color: "#fff",
        },
      }}
      title="Definir como capa"
    >
      ⭐
    </Box>
  )}

  {/* REMOVER */}
  <Box
    onClick={(e) => {
      e.stopPropagation();
      handleRemovePhoto(index);
    }}
    sx={{
      width: 40,
      height: 40,
      borderRadius: "50%",
      backgroundColor: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      transition: "all .2s ease",
      "&:hover": {
        backgroundColor: "#d32f2f",
        color: "#fff",
      },
    }}
    title="Remover foto"
  >
    <Trash2 size={20} />
  </Box>
</Box>


          {/* NOME / STATUS */}
          <Typography
            fontSize="0.7rem"
            p={0.5}
            noWrap
            bgcolor="white"
            title={image.file?.name ?? image.url}
          >
            {image.file?.name ?? "Imagem cadastrada"}
          </Typography>
        </Box>
      );
    })}
  </Box>
)}

    </Box>
  </Box>
  <Box borderRadius={1} p={2} gap={1} bgcolor="white">
      <Typography
        fontWeight="bold"
        fontSize="1.3rem"
        color="black"
        mt={2}
        mb={1}
      >
        Acessórios do veículo *
      </Typography>
      <Divider sx={{ width: "100%", my: 2, borderBottomWidth: 2 }} />
      <Box
        mt={2}
        display="grid"
        gridTemplateColumns="repeat(2, 1fr)"
        gap={1}
        width="100%"
      >
        {acessorios.map((item) => (
          <Box
            key={item.id}
            display="flex"
            alignItems="center"
            gap={1}
          >
            <Checkbox
              checked={item.isActive}
              onChange={() => handleToggleAcessorio(item.id)}
              sx={{
                color: "#dee2e6",
                "&.Mui-checked": {
                  color: colorPrimary,
                },
              }}
            />

            <Typography
              fontSize="0.95rem"
              color="black"
            >
              {item.label}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  </Box>
  <Stack display={"flex"} flexDirection={"row"} mt={2} flexGrow={1} justifyItems={"center"} alignContent={"center"} alignItems={"center"} justifyContent={"flex-end"} gap={2}>
    <div>
  <Button
    variant='text'
    onClick={() => {
    navigate("/anuncios");
    }}
    type='button'
  >
  <ArrowBack fontSize='medium' />
    <span>Voltar</span>
  </Button>
    </div>
  <Button
  fitContent={true}
  variant="large"
  type="button"
  onClick={handleSubmit(onSubmitAds)}
  >
  <SaveOutlined fontSize='medium' />
  Salvar
  </Button>
  {isEdit && (status ==='1' || status === '2') && ativo ==='1'? (
      <Button 
  fitContent={true}
  variant="large"
  type="button"
  onClick={handleSubmit(
  handleRenew,
  )}
  >
  <SaveOutlined fontSize='medium' />
  Renovar
  </Button>
  ) : undefined}
  {adId && (status === "0" || status === "2") && ativo === '0'? (
      <Button 
  fitContent={true}
  variant="large"
  type='button'
  onClick={submitPublicaAd}
  >
  <SaveOutlined fontSize='medium' />
  Publicar
  </Button>
  ): undefined}
  {adId && ativo == '1'? (
  <Button
  fitContent={true}
  variant='largeRed'
  type="button"
  onClick={submitDesativarAd}
  >
  <DeleteOutlined fontSize='medium' />
  Desativar
  </Button>
  ) : undefined}
  </Stack>
</form>
</Box>
    </>
    );
}


